import { render, staticRenderFns } from "./AddLegacyUser.vue?vue&type=template&id=3353407c&scoped=true&"
import script from "./AddLegacyUser.vue?vue&type=script&lang=js&"
export * from "./AddLegacyUser.vue?vue&type=script&lang=js&"
import style0 from "./AddLegacyUser.vue?vue&type=style&index=0&id=3353407c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3353407c",
  null
  
)

export default component.exports